<script lang="ts">
  import { flattenDeep } from 'lodash-es'

  import { currentQuestion, surveyStatus, progress, progressCount } from '../stores'
  import type { Question } from '../types/question'
  import type { SurveyStatus } from '../types/survey'

  const updateStatus = (surveyStatus: SurveyStatus, currentQuestion: Question) => {
    console.log(surveyStatus)
    const flatUserAnswersList = flattenDeep(surveyStatus.userAnswersList)

    const previousQuestionId = currentQuestion.previousQuestionId(surveyStatus.userAnswersList)

    // add flag
    let currentUserAnswer = flatUserAnswersList.filter(
      (answer) => answer.questionId === previousQuestionId
    )
    currentUserAnswer.forEach((answer) => (answer.isOldAnswer = true))

    return {
      ...surveyStatus,
      currentUserAnswer: currentUserAnswer,
      currentQuestionId: previousQuestionId,
    }
  }

  const moveBackward = (surveyStatus: SurveyStatus, currentQuestion: Question) => {
    $progress = $progress - 1
    $progressCount = $progressCount - 1
    return updateStatus(surveyStatus, currentQuestion)
  }
</script>

<svelte:window
  on:keydown={(event) => {
    if (event.key === 'ArrowLeft') {
      event.preventDefault()
      $surveyStatus = moveBackward($surveyStatus, $currentQuestion)
    }
  }}
/>

<button
  on:click={() => {
    $surveyStatus = moveBackward($surveyStatus, $currentQuestion)
  }}
  ><svg width="26" height="19" viewBox="0 0 26 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.57215 18.3334L11.1044 16.7979L5.04068 10.7103L25.1211 10.7103L25.1211 8.53224L5.04068 8.53224L11.1044 2.44464L9.57215 0.909133L0.878672 9.62125L9.57215 18.3334Z"
      fill="#4E4E4E"
    />
  </svg></button
>

<style>
  button {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    background: transparent;
    color: #4e4e4e;
    border: none;
    padding: 1.3rem 1.5rem;
    margin: 0;
    border-radius: 0;
  }

  button:active {
    background-color: transparent;
  }
</style>
